import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/star.svg'
import _imports_1 from '@/assets/icons/simple_tree.svg'
import _imports_2 from '@/assets/icons/couple_gray_150.png'
import _imports_3 from '@/assets/icons/share_60.png'
import _imports_4 from '@/assets/logos/GoldieMay_gold_64.png'


const _withScopeId = n => (_pushScopeId("data-v-f7c598e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plans-page container-lg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Share your family tree today"),
  /*#__PURE__*/_createElementVNode("h4", null, "Create a fun, endless learning experience your family will love")
], -1))
const _hoisted_3 = { class: "row list-unstyled plan-list" }
const _hoisted_4 = {
  key: 0,
  class: "recommend exp"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "recommend"
}
const _hoisted_10 = { class: "plan" }
const _hoisted_11 = { class: "plan-description" }
const _hoisted_12 = { class: "plan-price" }
const _hoisted_13 = { class: "price-name" }
const _hoisted_14 = {
  key: 0,
  class: "price"
}
const _hoisted_15 = { class: "billed" }
const _hoisted_16 = {
  key: 1,
  class: "price free"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "No payment now or later", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "plan-select" }
const _hoisted_21 = {
  key: 1,
  type: "button",
  class: "btn btn-secondary current",
  disabled: ""
}
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = { class: "list-unstyled plan-features" }
const _hoisted_24 = { class: "tree-limit" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Tree"
}, null, -1))
const _hoisted_26 = { class: "unit" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "person-limit" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Person"
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "no person limit")
  ])
], -1))
const _hoisted_28 = { class: "content-limit" }
const _hoisted_29 = { class: "unit" }
const _hoisted_30 = { class: "sharing-limit" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Sharing"
}, null, -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "person sharing limit", -1))
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "no sharing limit", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "integration"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "GoldieMay"
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "Goldie May integration")
], -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footnote" }, "Limits may be imposed for excessive use.", -1))

import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { hideModalAsync, usePageTitle } from '@/util/AppUtil'
import { defaultPlanId, getPlanTermPrice, Subscription, SubscriptionPlan, subscriptionPlans } from '@/gp/GroupAdminModel'
import { useSubscriptionStore } from '@/gp/SubscriptionStore'
import { useTokenManager } from '@/auth/TokenManager'
import { ImageIcon } from '@zhuowenli/vue-feather-icons'
import { ByteSizeUtil } from '@/util/ByteSizeUtil'
import SubscriptionConfirmPlanModal from '@/account/SubscriptionConfirmPlanModal.vue'
import PaymentModal from '@/account/PaymentModal.vue'
import { pluralize } from '@/util/LanguageUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlansPage',
  setup(__props) {

const loadingRef = ref(false)
const subRef = ref<Readonly<Subscription>>()
const selectedPlanIdRef = ref(defaultPlanId)
const confirmModalRef = ref<InstanceType<typeof SubscriptionConfirmPlanModal>>()
const paymentModalRef = ref<InstanceType<typeof PaymentModal>>()

const subStore = useSubscriptionStore()
const router = useRouter()
const tokenManager = useTokenManager()

usePageTitle('Plans')

const plansRef = computed(() => subscriptionPlans.filter(p => p.baseType != 'pro'))
const isAnonRef = computed(() => !tokenManager.current.isValid)
const canEditRef = computed(() => !isAnonRef.value && !tokenManager.current.isSupervised)
const currentPlanIdRef = computed(() => subRef.value?.items.at(0)?.price?.productId ?? defaultPlanId)

onMounted(async () => {
  loadingRef.value = true
  try {
    const subs = await subStore.getSubscriptionListForUserAsync(undefined)
    subRef.value = subs?.at(0) // HACK: assume max 1 subscription for now
  }
  finally {
    loadingRef.value = false
  }
})

watch(subRef, () => {
  selectedPlanIdRef.value = currentPlanIdRef.value
}, { immediate: true })

function getPlanContentLimit(plan: SubscriptionPlan) {
  const limitBytes = plan.contentLimit * (1024 * 1024) // MB to bytes
  return ByteSizeUtil.toReadableParts(limitBytes)
}

function onSelectPlan(plan: SubscriptionPlan) {
  if (isAnonRef.value) {
    // sign up first, then come back here
    router.push({ path: '/signup', query: { redirect_uri: '/plans' } })
  }
  else {
    confirmModalRef.value?.open(plan.id)
  }
}

async function addAsync(newPlanId: string) {
  try {
    const addResponse = await subStore.addAsync(newPlanId)
    await hideModalAsync(confirmModalRef.value!.$el)
    paymentModalRef.value!.open(addResponse.paymentIntentId!, addResponse.clientSecret!)
  }
  catch (error) {
    confirmModalRef.value?.addFailed()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plansRef.value, (p) => {
        return (_openBlock(), _createElementBlock("li", {
          key: p.id,
          class: "col-sm"
        }, [
          (p.baseType == 'plus')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createTextVNode(" Best experience ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["plan-name", { free: !p.price }])
            }, _toDisplayString(p.displayName), 3),
            _createElementVNode("div", _hoisted_11, _toDisplayString(p.description), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(p.priceName), 1),
              (p.price)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", null, "$" + _toDisplayString(p.price.toFixed(2)) + "/month", 1),
                    _createElementVNode("div", _hoisted_15, "$" + _toDisplayString(_unref(getPlanTermPrice)(p).toFixed(0)) + " for " + _toDisplayString(p.termMonths) + " months", 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
            ]),
            _createElementVNode("div", _hoisted_20, [
              (!loadingRef.value && p.id == currentPlanIdRef.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (isAnonRef.value)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "/signup",
                          class: "btn btn-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Get started ")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("button", _hoisted_21, " Current plan "))
                  ], 64))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-primary",
                    disabled: loadingRef.value,
                    onClick: ($event: any) => (onSelectPlan(p))
                  }, " Select this plan ", 8, _hoisted_22))
            ]),
            _createElementVNode("ul", _hoisted_23, [
              _createElementVNode("li", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(p.treeLimit), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(pluralize)(p.treeLimit ?? 0, ["tree", "trees"])), 1)
                ])
              ]),
              _hoisted_27,
              _createElementVNode("li", _hoisted_28, [
                _createVNode(_unref(ImageIcon), {
                  size: "1x",
                  alt: "Photo"
                }),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(getPlanContentLimit(p)?.value.toFixed(0)), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(getPlanContentLimit(p)?.unit) + " photos", 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_30, [
                _hoisted_31,
                (p.shareLimit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createTextVNode(_toDisplayString(p.shareLimit), 1),
                      _hoisted_33
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
              ]),
              (!p.shareLimit)
                ? (_openBlock(), _createElementBlock("li", _hoisted_37, _hoisted_40))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ]),
    _hoisted_41,
    _createVNode(SubscriptionConfirmPlanModal, {
      ref_key: "confirmModalRef",
      ref: confirmModalRef,
      onAdd: addAsync
    }, null, 512),
    _createVNode(PaymentModal, {
      ref_key: "paymentModalRef",
      ref: paymentModalRef
    }, null, 512)
  ]))
}
}

})